import { render, staticRenderFns } from "./ProjectProperties.vue?vue&type=template&id=d92865ae&"
import script from "./ProjectProperties.vue?vue&type=script&lang=js&"
export * from "./ProjectProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports